import React from 'react'
import { Pagination } from 'antd';
import moment from 'jalali-moment';
import 'moment/locale/fa';
import { ReactComponent as Leftarrow  } from "../../assets/img/icons/arrow-left-green2.svg"
import {ReactComponent as Rightarrow} from "../../assets/img/icons/arrow-right-green2.svg"

moment.locale('fa');
function itemRender(current, type, originalElement) {
  if (type === 'next') {
    return <a><Leftarrow /></a>;
  }else if (type === 'prev')
  {
    return <a><Rightarrow /></a>;
  }

  return originalElement;
}

function PersianPagination({total =10,setcurrentPage,pageSize =16}) {
  return (
    <div className='pagination'>
    <Pagination
    defaultCurrent={1}
    total={total}
    itemRender={itemRender}
    showQuickJumper
    showLessItems
    showSizeChanger={false}
    pageSize={pageSize}
    onChange={(page)=>setcurrentPage(page)}
    locale={{
    items_per_page: 'تعداد موارد در هر صفحه:',
    jump_to: 'رفتن به صفحه :',
    page: `از ${Math.floor(total/pageSize) }`,
    prev_page: 'صفحه قبل',
    next_page: 'صفحه بعد',
    prev_5: '۵ صفحه قبلی',
    next_5: '۵ صفحه بعدی',
    prev_3: '۳ صفحه قبلی',
    next_3: '۳ صفحه بعدی',
  }}
/>
</div>
  );
}









export default PersianPagination